import { render, staticRenderFns } from "./LH6giftDetail.vue?vue&type=template&id=9102ed24&scoped=true&"
import script from "./LH6giftDetail.vue?vue&type=script&lang=js&"
export * from "./LH6giftDetail.vue?vue&type=script&lang=js&"
import style0 from "./LH6giftDetail.vue?vue&type=style&index=0&id=9102ed24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9102ed24",
  null
  
)

export default component.exports